import Vue from 'vue';
import Inputmask from 'inputmask/lib/inputmask';
import 'inputmask/lib/extensions/inputmask.numeric.extensions';

Inputmask.extendDefinitions({
  _: {
    // eslint-disable-next-line no-useless-escape
    validator: '[0-9\(\)\.\+/ ]',
    definitionSymbol: '9',
  },
});

Vue.directive('mask', {
  bind: (el, binding) => {
    Inputmask(binding.value).mask(el);
  },
  unbind: (el) => {
    if (typeof el.inputmask?.remove === 'function') {
      el.inputmask.remove();
    }
  },
});
